import { useLocation, type Location } from 'react-router-dom';

export interface LocationWithState<T> extends Location {
  state: T;
}

export interface CustomLocationState {
  from?: string;
  username?: string;
}

export const useLocationWithState = () => {
  return useLocation() as LocationWithState<CustomLocationState>;
};
